import React, { useState, useEffect } from 'react';

interface TimeDifferenceProps {
    dateFrom: Date;
    dateTo: Date | null;
}

const TimeDifference: React.FC<TimeDifferenceProps> = ({ dateFrom, dateTo }) => {
    const [now, setNow] = useState<Date>(new Date());

    useEffect(() => {
        if (!dateTo) {
            const intervalId = setInterval(() => {
                setNow(new Date());
            }, 1000);

            return () => {
                clearInterval(intervalId);
            };
        }
    }, [dateTo]);

    const getDifferenceInSeconds = (date1: Date, date2: Date): number => {
        const differenceInMilliseconds = Math.abs(date1.getTime() - date2.getTime());
        return Math.round(differenceInMilliseconds / 1000);
    };

    const formatTimeDifference = (seconds: number): string => {
        const hours = Math.floor(seconds / 3600);
        seconds %= 3600;
        const minutes = Math.floor(seconds / 60);
        seconds %= 60;

        let result = '';
        if (hours > 0) result += `${hours} h `;
        if (minutes > 0) result += `${minutes} m `;
        if (seconds > 0) result += `${seconds} s`;

        return result.trim();
    };

    const timeDifference: number = getDifferenceInSeconds(dateFrom, dateTo || now);
    const formattedTimeDifference: string = formatTimeDifference(timeDifference);

    return (
        <div>
            {formattedTimeDifference}
        </div>
    );
};

export default TimeDifference;